import {
  applyOrthancAuthHeaders,
  getOrthancAddress,
  getOrthancCredentials,
} from '@ohif/core/src/utils/orthancAPI';

import { IS_OFFLINE_BUILD } from './buildMode';

// Base URL of the Orthanc server, shared by every DICOMweb root below
const orthancAddress = getOrthancAddress();

// Offline: same-origin proxy, which injects its own credentials. Online:
// `auth` (a string, it survives the sessionStorage round trip of the servers)
// feeds DICOMWeb.getAuthorizationHeader, `beforeSend` the XHR-based loaders.
const requestOptions = IS_OFFLINE_BUILD
  ? { requestFromBrowser: true }
  : {
      requestFromBrowser: true,
      auth: getOrthancCredentials(),
      beforeSend: applyOrthancAuthHeaders,
    };

// OHIF viewer configuration: routing, panels and the Orthanc DICOMweb server
export const ohifViewerConfig = {
  routerBasename: '/',
  extensions: [],
  showStudyList: true,
  filterQueryParam: false,
  // Drops the Measurements panel and its toolbar entry. Read in App.js by
  // _initExtensions, which then never registers the extension.
  disableMeasurementPanel: true,
  servers: {
    dicomWeb: [
      {
        name: 'ORTHANC',
        wadoUriRoot: `${orthancAddress}/wado`,
        qidoRoot: `${orthancAddress}/dicom-web`,
        wadoRoot: `${orthancAddress}/dicom-web`,
        qidoSupportsIncludeField: true,
        imageRendering: 'wadors',
        thumbnailRendering: 'wadors',
        enableStudyLazyLoad: true,
        requestOptions,
      },
    ],
  },
};
